import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

// 	MISSING
const getLegoGameData = async (attribute) => {
	// calls api method "makeAPIRequest"
	try {
		const api = await getAPI();
		const response = await api.get(`legogame/request/${attribute}`);
		return response;
	} catch (error) {
		checkAuthError(error);

		console.error('getLegoGameData', error);
		return null;
	}
};

const getProductionStepsStats = async () => {
	// calls api method "getLegoGameStats"
	try {
		const api = await getAPI();
		const response = await api.get(`legogame/stats`);
		return response;
	} catch (error) {
		checkAuthError(error);

		console.error('getProductionStepsStats', error);
		return null;
	}
};

const uploadImage = async (form) => {
	// calls api method "getLegoGameStats"
	try {
		const api = await getAPI();
		const response = await api.post(`uploadImage`, form);
		return response;
	} catch (error) {
		checkAuthError(error);

		console.error('getProductionStepsStats', error);
		return null;
	}
};

export { getLegoGameData, getProductionStepsStats, uploadImage };
